import Flex from '@blocks/Flex'
import Info from '@blocks/Info'
import Photo from '@blocks/Photo'
import PhotoSlider from '@customer/components/sliders/Photo'
import useSlider from '@hooks/useSlider'
import { ReactComponent as AcceptanceIcon } from '@icons/acceptance.svg'
import { ReactComponent as EditIcon } from '@icons/edit.svg'
import { ReactComponent as TrophyIcon } from '@icons/trophy.svg'
import React from 'react'
import { ReactComponent as OrganizationIcon } from '@icons/organization.svg'

export default function GalleryPhoto({ data, gallery }: Props) {
    const slider = useSlider(PhotoSlider, {
        photo: data,
        onDelete: gallery.methods.destroy,
        onChange: gallery.methods.update
    })

    return (
        <Photo 
            data={data} 
            onClick={slider.open} 
            toolbar={[
                { icon: <EditIcon />, onClick: slider.open }
            ]} 
            middle={(
                <Flex justifyContent="flex-end" gap="5px">
                    <Info tip="Salons" tipId="salons" label={data.salons_count.toString()} icon={<OrganizationIcon />} />
                    <Info tip="Acceptances" tipId="acceptances" label={data.acceptances_count.toString()} icon={<AcceptanceIcon />} />
                    <Info tip="Awards" tipId="awards" label={data.awards_count.toString()} icon={<TrophyIcon />} />
                </Flex>
            )} />
    )
}

interface Props {
    data: Interfaces.Photo.Includes<"acceptances_count" | "awards_count" | "salons_count">
    gallery: Customer.Models.Gallery
}